import Vue from "vue";
import VueEvents from "vue-events";
Vue.use(VueEvents);
